import { LogLevel, type Configuration } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string;
const authority =
    (import.meta.env.VITE_AZURE_AUTHORITY as string) ??
    "https://login.microsoftonline.com/common";

export const apiScope = import.meta.env.VITE_API_SCOPE as string;

// Basic login - NO admin consent required
// Use ONLY User.Read which has "Admin consent required: No"
export const loginRequest = {
    scopes: ["User.Read"],
};

// API access - includes custom API scope
export const apiTokenRequest = {
    scopes: [apiScope],
};

export const msalConfig: Configuration = {
    auth: {
        clientId,
        authority,
        redirectUri: window.location.origin + "/",
        postLogoutRedirectUri: window.location.origin + "/"
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false, // CRITICAL: Don't use cookies for redirect handling
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Warning,
            loggerCallback: (_level, message, containsPii) => {
                if (!containsPii) console.log(message);
            }
        },
        allowRedirectInIframe: false,
        windowHashTimeout: 9000,
        iframeHashTimeout: 9000,
    }
};
